export default __webpack_public_path__ + "static/media/monetizationOn.65850d4e.svg";